import type { WelcomeStep } from "../types/WelcomeFlowTypes";

// The tour's centered intro; anchored steps are all deck-local — no Carbon0 view describes an
// empty inventory (see decks/materialsCreateDeck.ts).
export const materialsCreateNewUserSteps: WelcomeStep[] = [{ key: "materials-create-welcome", label: "Welcome", centered: true }];
